import { getShellApiInstance } from '../../common/shell-api-helpers'
import { isFreeUser, isTrialUser } from '../../common/user-helpers'
import { TrialBannerService } from '../../services/banner/trial-banner-service'
import { getLaunchDarklyFlag } from '../../services/feature-flags'
import { LaunchDarklyVariations } from '../../services/feature-flags/models'

export const initializeTrialBanner = () => {
  const trialBannerService = new TrialBannerService()
  return canShowTrialBanner() ? trialBannerService.show() : trialBannerService.hide()
}

/**
 * Checks if user has an active product trial to show the trial banner
 * @returns true/false
 */
export const canShowTrialBanner = (): boolean => {
  if (!getLaunchDarklyFlag(LaunchDarklyVariations.SHELL_ENABLE_TRIAL_BANNER)) {
    return false
  }
  const isAuthenticated = !!getShellApiInstance()?.user?.key
  const productTrialExists = !!getShellApiInstance()?.user?.productTrial
  if (!isAuthenticated) {
    return false
  }
  if (!productTrialExists) {
    return false
  }
  return isFreeUser() || isTrialUser()
}
